import React, {useContext} from 'react';
import classnames from '../../src/helpers/classnames';
import trans from '../../src/helpers/trans';
import {LocaleContext} from '../../src/contexts/LocaleContext';

export default function HasNewCommentIndicator({active, className}: { active: boolean, className?: string }) {
    const {locale} = useContext(LocaleContext);
    if (!active) {
        return null;
    }

    return <>
        <i
                className={classnames(className, 'fa-comments', {
                    'fas': active,
                    'far opacity-50': !active,
                })}
                title={trans(`OrdersIndex.has${active ? '' : '-not'}-new-comments`, locale)}
        />
    </>;
}
